<template>
	<el-dialog :visible.sync="visible" :title="$t('nat.text.addSnatRule')" :close-on-click-modal="false"
		:before-close="handleClose"
        :modal-append-to-body="false" class="add-snat-rule-dialog">
		<el-form ref="form" label-width="130px" :rules="rules" :model="form">
			<!-- NAT网关 -->
			<el-form-item :label="$t('nat.text.nat') | withColon">
				<span>{{ natInfo.name | maybeEmpty }}</span>
			</el-form-item>
			<!-- SNAT规则粒度 -->
			<el-form-item :label="$t('nat.text.snatRuleGranularity') | withColon">
				<el-radio-group v-model="granularity" @change="granularityRadioChange">
					<el-radio v-for="(item, index) in SnatRuleGranularityConstant" :label="item.value" :key="index">{{
						item.label }}</el-radio>
				</el-radio-group>
			</el-form-item>
			<!--所属子网-->
			<el-form-item :label="$t('privateNetInstance.subnetBelongTo') | withColon" required
				v-if="granularity === 'subnet'">
				<el-select multiple style="width: 50%;" v-model="form.selectedSubnets" filterable
					popper-class="ip-address-select" :no-data-text="$t('privateNetInstance.notSubnet')"
					:placeholder="$t('privateNetInstance.chooseSubnet')" @visible-change="value => getSubnetList(value)"
					@change="value => changeSubnet(value)">
					<el-option v-for="item in subnets" :key="item.subnetId" :label="item.text" :value="item.subnetId">
					</el-option>
				</el-select>
				<!--以新页签的方式打开子网列表页-->
				<a href="/subnet/list" target="_blank">{{ $t('privateNetInstance.createSubNet') }}</a>
				<!--主要cidr,次要cidr-->
				<span slot="hint" v-if="subnetCidr">{{ $t('nat.text.subnetCidr', [subnetCidr]) }}</span>
				<span slot="hint" v-if="subnetSecondaryCidr">{{ $t('nat.text.subnetSecondaryCidr', [subnetSecondaryCidr])
				}}</span>
			</el-form-item>
			<!--云物理服务器-->
			<el-form-item :label="$t('nat.text.server') | withColon" required v-if="granularity === 'server'">
				<el-select multiple style="width: 50%;" v-model="form.selectedServers" filterable
					popper-class="ip-address-select" :no-data-text="$t('nat.placeholder.emptyInstance')"
					:placeholder="$t('nat.placeholder.server')" @visible-change="value => getServerList(value)"
					@change="value => changeServer(value)">
					<el-option v-for="item in servers" :key="item.privateIp" :label="item.text" :value="item.privateIp">
					</el-option>
				</el-select>
			</el-form-item>
			<!--自定义网段-->
			<el-form-item :label="$t('nat.text.customCidr') | withColon" required v-if="granularity === 'custom'"
				:show-message="false" key="customCidr" prop="customCidr">
				<el-input style="width: 50%;" v-model="form.customCidr"
					:placeholder="$t('nat.placeholder.customCidr')"></el-input>
				<p class="el-form-item-help" v-if="this.formTag.customCidr == 'error'"
					:class="{ 'el-form-item-help-error': this.formTag.customCidr == 'error' }">
					{{ $t('nat.help.customCidr') }}
				</p>
			</el-form-item>
			<!--弹性公网ip-->
			<el-form-item :label="$t('eip.text.eip') | withColon" required>
				<el-select multiple style="width: 50%;" v-model="form.eipIds" :no-data-text="$t('nat.placeholder.notEip')"
					:placeholder="$t('nat.placeholder.eip')" @visible-change="value => getEipList(value)"
					@change="value => changeEip(value)">
					<el-option v-for="item in eips" :key="item.eipId" :label="item.eip" :value="item.eipId">
					</el-option>
				</el-select>
			</el-form-item>
			<!--描述-->
			<el-form-item :label="$t('create.text.desc') | withColon" prop="desc" :show-message="false" ref="desc">
				<el-input type="textarea" :rows="4" style="width: 50%;" v-model="form.desc"></el-input>
				<p class="el-form-item-name-help" :class="{ 'el-form-item-help-error': this.formTag.desc == 'error' }">
					{{ $t('create.help.desc') }}</p>
			</el-form-item>
		</el-form>
		<div slot="footer">
			<el-button @click="cancelBind">
				{{ $t('privateNetInstance.cancel') }}
			</el-button>
			<el-button @click="sureBind" type="primary" :disabled="isConfirmDisabled" :loading="sureBtnLoading">
				{{ $t('privateNetInstance.bindSure') }}
			</el-button>
		</div>
	</el-dialog>
</template>

<script>
import {
	SnatRuleGranularityConstant,
	NatRuleConstant,
	AliasIpRuleConstant,
	ValidOrErrorConstant
} from '@/common/Constants';
import { getNatPrivateIpsApi, getNatEipsApi, createSNatRulesApi } from '@/api/nat/detail/actions';
export default {
	name: 'AddSnatRule',
	props: {
		visible: {
			type: Boolean,
			default: false
		},
		natInfo: {
			type: Object,
			default: {}
		}
	},
	data() {
		this.NatRuleConstant = NatRuleConstant;
		this.AliasIpRuleConstant = AliasIpRuleConstant;
		this.ValidOrErrorConstant = ValidOrErrorConstant;
		const validateLength = (rule, value, callback) => {
			if (this.form.desc.length > 256) {
				callback(new Error());
			} else {
				callback();
			}
		};
		// 校验IPv4范围是否为合规IP
		const cidrInputValidator = (rule, value, callback) => {
			const ipRegex = AliasIpRuleConstant;
			if (!value) {
				this.formTag.customCidr = ValidOrErrorConstant.ERROR
				return callback(new Error(this.$t('subnet.help.aliasIpCannotBeNull')));
			}
			if (!ipRegex.test(value)) {
				this.formTag.customCidr = ValidOrErrorConstant.ERROR
				return callback(new Error(this.$t('subnet.help.cidrNotStandard')));
			}
			this.formTag.customCidr = ValidOrErrorConstant.VALID
			callback();
		};
		return {
			form: {
				selectedSubnets: [],
				selectedServers: [],
				customCidr: '',
				eipIds: [],
				desc: "",
			},
			formTag: {
				desc: 0,
				customCidr: ValidOrErrorConstant.VALID,
			},
			rules: {
				desc: [
					{ type: 'string', validator: validateLength, trigger: 'blur' }
				],
				customCidr: [
					{
						type: 'string', validator: cidrInputValidator, trigger: 'blur',
					}
				],
			},
			SnatRuleGranularityConstant: SnatRuleGranularityConstant,
			granularity: 'subnet',
			subnets: [],
			subnetCidr: '',
			subnetSecondaryCidr: '',
			servers: [],
			eips: [],
            sureBtnLoading: false,
		};
	},
	computed: {
		// 确定按钮是否置灰
		isConfirmDisabled: function () {
			if (this.granularity === 'subnet') {
				return !this.form.selectedSubnets.length || !this.form.eipIds?.length;
			} else if (this.granularity === 'server') {
				return !this.form.selectedServers.length || !this.form.eipIds?.length;
			} else if (this.granularity === 'custom') {
				return !this.form.customCidr || !this.form.eipIds?.length;
			}
		},
	},
	watch: {
	},
	created() {
	},
	methods: {
        // radio 切换后清空已选/已填的数据
        granularityRadioChange() {
            this.form.selectedSubnets = [];
            this.form.selectedServers = [];
            this.form.customCidr = '';

            this.formTag.customCidr = ValidOrErrorConstant.VALID;
            this.formTag.desc =0;
			this.subnetCidr = '';
			this.subnetSecondaryCidr = '';
        },
		handleClose() {
            this.sureBtnLoading = false;
			this.resetSnatRule();
			this.$emit('update:visible', false);
		},
		cancelBind() {
			this.handleClose();
		},
		sureBind() {
            this.sureBtnLoading = true;
			const params = {
				region: this.natInfo.region,
				clientToken: Normal.getClientToken(),
				natGatewayId: this.natInfo.natGatewayId,
				granularity: this.granularity,
				eipIds: this.form.eipIds,
				description: this.form.desc
			};
			if (this.granularity === 'subnet') {
				params.snatRuleCreates = this.form.selectedSubnets.map(item => {
					return {
						"subnetId": item
					}
				})
			} else if (this.granularity === 'server') {
				params.snatRuleCreates = this.servers.filter(item => this.form.selectedServers.includes(item.privateIp));
			} else if (this.granularity === 'custom') {
				params.snatRuleCreates = [];
				params.snatRuleCreates.push({
					"customCidr": this.form.customCidr
				})
			}
			createSNatRulesApi(params).then((res) => {
				this.$message.success(this.$t('privateNetInstance.operateSuccess'));
                this.handleClose();
                this.$emit('refresh');
			})
				.catch(async (err) => {
                    this.sureBtnLoading = false;
					const { response } = err.data;
					try {
						const json = await response.json();
						this.$message.error(json.errmsg);
					} catch (ex) {
						console.log(ex);
					}
				})
				.finally(() => {
					// this.handleClose();
					// this.$emit('refresh');
				});
		},
		getSubnetList(visible) {
			if (!visible) {
				return
			}
			const params = {
				vpcId: this.natInfo.vpcId,
				region: this.natInfo.region,
				natGatewayId: this.natInfo.natGatewayId,
			};
			Ajax.get('/api/cps/listSubnets', params)
				.then((res) => {
					if (res.errno === 10000 && res.data) {
						this.subnets = res.data.subnets.map(item => {
							item.text = `${item.name}(${item.subnetId})`;
							return item
						});
					}
				}).finally(() => {
				});
		},

		changeSubnet(value) {
			if (value.length === 1) {
				let subnetId = value[0];
				let chooseSubnet = this.subnets.filter(item => item.subnetId === subnetId).reduce((obj, curr) => {
					obj.cidr = curr.cidr;
					obj.secondaryCidr = curr.secondaryCidr;
					return obj
				}, {});
				this.subnetCidr = chooseSubnet.cidr;
				this.subnetSecondaryCidr = chooseSubnet.secondaryCidr;
			} else {
				this.subnetCidr = '';
				this.subnetSecondaryCidr = '';
			}
		},

		getServerList(visible) {
			if (!visible) {
				return
			}
			const params = {
				vpcId: this.natInfo.vpcId,
				region: this.natInfo.region,
				natGatewayId: this.natInfo.natGatewayId,
				service: NatRuleConstant.SNAT
			};
			getNatPrivateIpsApi(params).then((res) => {
				if (res.errno === 10000 && res.data) {
					this.servers = res.data.cnatPrivateIps.map(item => {
						item.text = `${item.privateIp}(${item.instanceId})`;
						return item
					});
				}
			}).finally(() => {
			});
		},

		changeServer(value) {
			//console.log(value);
		},

		getEipList(visible) {
			if (!visible) {
				return
			}
			const params = {
				region: this.natInfo.region,
				natGatewayId: this.natInfo.natGatewayId,
				service: NatRuleConstant.SNAT
			};
			getNatEipsApi(params).then((res) => {
				if (res.errno === 10000 && res.data) {
					this.eips = res.data.cnatEIPList.map(item => {
						return item
					});
				}
			}).finally(() => {
			});
		},

		changeEip(value) {

		},

		resetSnatRule() {
			this.form = {
				selectedSubnets: [],
				selectedServers: [],
				eipIds: [],
				customCidr: '',
				desc: "",
			};
			this.subnetCidr = '';
			this.subnetSecondaryCidr = '';
		}
	},
};
</script>

<style lang="scss">
.add-snat-rule-dialog {
    .el-form-item .el-form-item-help {
        padding-bottom: 0 !important;
    }
    .el-form-item__error {
        padding-bottom: 0 !important;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/nat/AddSnatRule.vue